/**
 * Interface for the 'Custom View' data
 */
export interface CustomViewEntity {
    id: string | number; // Primary ID
}
